import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import ArrowRight from "components/icons/arrowRight"

import ContentWrapper from "styles/contentWrapper"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: #061627;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 1.05rem;
    padding-bottom: 1.05rem;
  }
`
const StyledLink = styled(Link)`
  color: #6485A8;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .logo {
    width: 1.75rem;
    height: 1.75rem;
    min-height: 1.75rem;
    border-radius: 0.22rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${props =>props.color};
    margin-left: 0.7rem;
    img {
      height: 0.93rem;
      width: auto;
    }
  }
  span {
    margin-left: 0.7rem;
  }
  svg {
    height: 0.93rem;
    width: auto;
    transform: rotate(180deg);
  }
`

const Breadcumbs = ({ link, logo, text, color }) => {
  return (
    <StyledSection  id="breadcumbB">
      <StyledContentWrapper>
          <StyledLink color={color} to={link}>
            <ArrowRight color="#6485A8" />
            {logo && (
              <div className="logo">
                <img src={logo} />
              </div>
            )}
            <span>{text}</span>   
          </StyledLink>
      </StyledContentWrapper>
    </StyledSection>
  )
}


export default Breadcumbs
